// 获取url参数
export const getQueryString = (name) =>{
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = (window.location.search).replaceAll("%3D","=").replaceAll("%26","&").substr(1).match(reg);
    if (r != null) {
        return decodeURIComponent(r[2]);
    };
    return null;
 }


// 先用650的宽度判断横竖屏
export const isLandspace = () => document.body.offsetWidth <= 650

// 判断是否是手机端浏览器
export const getBrowser = () =>{
    var ua = navigator.userAgent.toLowerCase();
    var btypeInfo = (ua.match( /firefox|chrome|safari|opera/g ) || "other")[ 0 ];
    if( (ua.match( /msie|trident/g ) || [] )[ 0 ] )
    {
        btypeInfo = "msie";
    }
    var pc = "";
    var prefix = "";
    var plat = "";
    //如果没有触摸事件 判定为PC
    var isTocuh = ("ontouchstart" in window) || (ua.indexOf( "touch" ) !== -1) || (ua.indexOf( "mobile" ) !== -1);
    if( isTocuh )
    {
        if( ua.indexOf( "ipad" ) !== -1 )
        {
            pc = "pad";
        } else if( ua.indexOf( "mobile" ) !== -1 )
        {
            pc = "mobile";
        } else if( ua.indexOf( "android" ) !== -1 )
        {
            pc = "androidPad";
        } else
        {
            pc = "pc";
        }
    } else
    {
        pc = "pc";
    }
    switch( btypeInfo )
    {
        case "chrome":
        case "safari":
        case "mobile":
            prefix = "webkit";
            break;
        case "msie":
            prefix = "ms";
            break;
        case "firefox":
            prefix = "Moz";
            break;
        case "opera":
            prefix = "O";
            break;
        default:
            prefix = "webkit";
            break
    }
    plat = (ua.indexOf( "android" ) > 0) ? "android" : navigator.platform.toLowerCase();
    return {
        version: (ua.match( /[\s\S]+(?:rv|it|ra|ie)[\/: ]([\d.]+)/ ) || [])[ 1 ],     //版本
        plat: plat,                   //系统
        type: btypeInfo,              //浏览器
        pc: pc,
        prefix: prefix,                //前缀
        isMobile: (pc == "pc") ? false : true              //是否是移动端
    };
}

export const getKrpano = async () => {
    return new Promise((res) => {
        let krpano = document.getElementById("fontrePano");

        if (!krpano) {
            setTimeout(() => {
                res(getKrpano());
            }, 500);
        } else {
            res(krpano);
        }
    });
};

// const notBase64 = /[^A-Z0-9+\/=]/i;
//
// export const isBase64 = (str) => {
//     // assertString(str); // remove this line and make sure you pass in a string
//     const len = str.length;  if (!len || len % 4 !== 0 || notBase64.test(str)) {
//         return false;
//     }
//     const firstPaddingChar = str.indexOf('=');
//     return firstPaddingChar === -1 ||
//         firstPaddingChar === len - 1 ||
//         (firstPaddingChar === len - 2 && str[len - 1] === '=');
// }

export const isBase64 = (str) => {
    if (str ==='' || str.trim() ===''){ return false; }
    try {
        return btoa(atob(str)) === str;
    } catch (err) {
        return false;
    }
}



export const diffPos = (pos1, pos2) => {
    console.log(pos2,pos1)
    if ( pos1.x.toFixed(2) === pos1.x.toFixed(2)
    && pos1.y.toFixed(2) === pos1.y.toFixed(2)
     && pos1.z.toFixed(2) === pos1.z.toFixed(2))  {
        return true;
    }
}

// 版本比较
export const versionCompare = (v1, v2) => {
    //将两个版本号拆成数组
    var arr1 = v1.split('.'),
        arr2 = v2.split('.');
    var minLength=Math.min(arr1.length,arr2.length);
    //依次比较版本号每一位大小
    for (var i = 0; i < minLength; i++) {
        if (parseInt(arr1[i]) != parseInt(arr2[i])) {
            return (parseInt(arr1[i]) > parseInt(arr2[i])) ? 1 : -1;
        }
    }
    // 若前几位分隔相同，则按分隔数比较。
    if (arr1.length == arr2.length) {
        return 0;
    } else {
        return (arr1.length > arr2.length) ? 1 : -1;
    }
}

// 节流
//func：需要执行的函数
//delay：自己设定的间隔时间（频率）
//immediate：是否立即执行，值为true则第一次触发立刻执行函数，默认为false是最后一次触发执行
//return：返回可被调用执行的函数
export function throttle(func,delay,immediate){
    //func为需要节流的函数，delay为节流的时间，immediate为是否需要先执行
    var timer = null;
    return function(){
        var context = this;
        var args = arguments;
        if(timer) clearTimeout(timer);
        if(immediate){
            //根据距离上次触发操作的时间是否到达delay来决定是否要现在执行函数
            var doNow = !timer;
            //每一次都重新设置timer，就是要保证每一次执行的至少delay秒后才可以执行
            timer = setTimeout(function(){
                timer = null;
            },delay);
            //立即执行
            if(doNow){
                func.apply(context,args);
            }
        }else{
            timer = setTimeout(function(){
                func.apply(context,args);
            },delay);
        }
    }
}
// 防抖
//func：需要执行的函数
//wait：检测防抖的间隔频率
//immediate：是否立即执行，值为true则第一次触发立刻执行函数，默认为false是最后一次触发执行
//return：返回可被调用执行的函数
export function debounce(func,wait=500,immediate=false){
    let timer=null;		//通过timer设置为null检测是否出现了定时器
    return function(...params){
        let now=immediate && !timer;  //immediate为true，timer为null时，now为true
        clearTimeout(timer);
        timer=setTimeout(()=>{
            timer=null;
            !immediate?func.call(this,...params):null;
        },wait);
        now?func.call(this,...params):null;  //now为true则为第一次触发，则立即执行
    }
}
